module.exports = __webpack_public_path__ + "static/media/jnvLogo.b4c1a526.png";